
import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, Button} from 'reactstrap';
import CdnImage from '../../components/cdnImage/cdnImage.js'
import ErrorComponent from '../../components/error/ErrorComponent.js'
import LoadingComponent from '../../components/loading/LoadingComponent'
import humanizeDuration from "humanize-duration";

const translator = require('../../utils/translator/translator');
const configurationManager = require('../../utils/config/configurationManager');
const stringUtil = require('../../utils/string/stringUtil');
const dateUtil = require('../../utils/dateUtil/dateUtil');
const staffUtility = require('../../utils/domain/staff/staffUtility');
const rmsApiProxyRetry = require('../../utils/api/rmsApiProxyRetry');
const jobsServer = require('../../utils/jobs/jobsServer.js');
const guidUtil = require('../../utils/guid/guidUtil.js');
const arraySort = require('array-sort');
var logger = require('../../utils/logger/logger');
var themeUtil = require('../../utils/view/themeUtil.js');

var stateManager = require('../../utils/state/stateManager.js');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction');
var staffLoginAction = require('../../utils/state/actions/staffLogin/staffLoginAction.js');

const height = '50vh';

class ClockingView extends Component 
{
    constructor(props)
    {
        super(props);

        this.onSwitchPanel = this.onSwitchPanel.bind(this);
        this.onClockIn = this.onClockIn.bind(this);
        this.onClockOut = this.onClockOut.bind(this);

        this.state = {};
        this.state.error = null;  

        this.state.status = "loading.required";
        this.state.panelSelection = "clocking"
        
        this.state.clockedInOutCurrentSession = false;

        this.state.lastClockedInDateTime = null;
        this.state.lastClockedOutDateTime = null;
        this.state.rotas = [];
    }

    render()
    {
        if (this.state.status == "loading.required")
        {
            this.state.status = "loading"
            this.loadDetails();
        }

        return(<Modal isOpen={true} centered animation={false} fade={false} style={{minWidth:'70vw', maxWidth:'70vw'}}>

                    <ModalHeader cssModule={{ 'modal-title': 'w-100' }} style={{background:'var(--background-color)', paddingBottom:'5px'}}>
                        <div className="caption primary-color d-flex justify-content-center">
                           {translator.getLabel("clocking")}
                        </div>
                    </ModalHeader>

                    <ModalBody style={{background:'var(--background-color)', paddingLeft:'10px', paddingRight:'10px', height: height}}>

                        <div className='h-100 d-flex flex-row'>

                            <div className='h-100 border-end' style={{width: '70%', overflowY:'auto'}}>
                                {this.renderInfoPanel()}
                            </div>

                            <div className='h-100 px-4 py-2' style={{width: '30%'}}>
                                {this.renderControlPanel()}
                            </div>

                        </div>

                    </ModalBody>
                </Modal>);
    }

    renderInfoPanel()
    {
        if (this.state.error != null)
            return this.renderErrorComponent();

        else if (this.state.status == "loading")
            return this.renderLoadingComponent();

        if (this.state.panelSelection == "clocking")
            return this.renderClockingPanel();

        return this.renderRotaPanel();
    }

    renderErrorComponent()
    {
        return <div className='h-100 d-flex flex-column justify-content-center'>
                    <ErrorComponent error={this.state.error}/>
                </div>
    }

    renderClockingPanel()
    {
        var component = null;
        if (this.state.lastClockedOutDateTime != null)
        {
            var differenceInMilliseconds = dateUtil.differenceInMilliseconds(this.state.lastClockedOutDateTime, this.state.lastClockedInDateTime);
            var caption = humanizeDuration(differenceInMilliseconds, {delimiter: " and ", units: ['h', 'm'], round: true});
            component = <div>
                            <div>{translator.getLabel("you_have_clocked_out_the_shift")}</div>
                            <div>{translator.getLabel("shift_duration")}: <b>{caption}</b>.</div>
                        </div>
        }

        else if (this.state.lastClockedInDateTime != null)
        {
            var differenceInMilliseconds = dateUtil.differenceInMilliseconds(dateUtil.getNow(), this.state.lastClockedInDateTime);
            var caption = humanizeDuration(differenceInMilliseconds, {delimiter: " and ", units: ['h', 'm'], round: true});
            
            var childComponent = null;
            if (!this.state.clockedInOutCurrentSession)
                childComponent = <div>
                                    <div>{translator.getLabel("shift_duration")}: <b>{caption}</b>.</div>
                                    <div style={{marginTop:'20px', marginLeft:'40px', marginRight:'40px'}}>
                                        <Button block className='btn-action' onClick={this.onClockOut}>{translator.getLabel("clock_out")}</Button>
                                    </div>
                                </div>

            component = <div>
                            <div>{translator.getLabel("you_started_shift_on")} <b>{dateUtil.formatDate(dateUtil.convertToLocalStandard(this.state.lastClockedInDateTime), "ddd DD, MMM  HH:mm")}</b>.</div>
                            {childComponent}
                        </div>
        }
        else
        {
            component = <div>
                            <div>{translator.getLabel("you_have_not_started_shift_yet")}</div>
                            <div style={{marginTop:'20px', marginLeft:'40px', marginRight:'40px'}}>
                                <Button className='btn-action' block onClick={this.onClockIn}>{translator.getLabel("clock_in")}</Button></div>
                        </div>
        }

        return <div className='h-100 d-flex flex-column justify-content-center' style={{textAlign:'center'}}>
                    {this.renderStaffPicture()}
                    <div className='primary-color' style={{textAlign:'center', marginBottom:'20px'}}>
                        {staffUtility.getStaffCompleteName(this.props.staff)}
                    </div>
                    {component} 
                </div>
    }

    renderRotaPanel()
    {

        if (this.state.rotas.length <= 0)
        {
            return <div className='h-100 d-flex flex-column justify-content-center caption primary-color align-items-center'>
                        <div>
                            {translator.getLabel("no_shifts_scheduled_for_you")}
                        </div>     
                    </div>
        }

        let components = [];
        let currentDate = null;
        this.state.rotas.forEach (rota =>
        {
            let localStart = dateUtil.convertToLocalStandard(rota.start);
            let localEnd = dateUtil.convertToLocalStandard(rota.end);
            let differenceInMilliseconds = dateUtil.differenceInMilliseconds(localEnd, localStart);
            let caption = humanizeDuration(differenceInMilliseconds, {delimiter: " and ", units: ['h', 'm'], round: true});

            if (currentDate == null || !dateUtil.isSame(currentDate, dateUtil.getDateComponent(localStart)))
            {
                var marginTop = components.length > 0 ? "30px" : "0px";
                currentDate = dateUtil.getDateComponent(localStart);
                components.push(<div className='caption primary-color' style={{marginTop: marginTop}}><b>{dateUtil.formatDate(currentDate, "ddd DD, MMM")}</b></div>)
                components.push(<hr className='primary-color' style={{marginTop:'2px'}}/>)
            }

            components.push(<div className='d-flex justify-content-between' style={{marginLeft:'0px'}}>
                                <div>✦&nbsp;&nbsp;{dateUtil.formatDate(localStart, "HH:mm")} - {dateUtil.formatDate(localEnd, "HH:mm")}</div>
                                <div>{caption}</div>
                            </div>)
        })

        return <div style={{paddingTop:'10px', paddingBottom:'30px', marginLeft:'20px', marginRight:'40px'}}>{components}</div>
    }

    renderLoadingComponent()
    {
        return <div className='h-100 d-flex flex-column justify-content-center'>
                    <LoadingComponent waitMessage={translator.getLabel("please_wait_loading_your_details")}/>
               </div>
    }

    renderControlPanel()    
    {
        let disabled =  this.state.status == "loading";
        let clockingButtonClass = 'btn-action';
        let rotaButtonClass = 'btn-action';

        if (!disabled)
        {
            if (this.state.panelSelection == "clocking")
                clockingButtonClass = 'btn-action-selected';
            else
                rotaButtonClass = 'btn-action-selected';
        }

        return <div className='h-100' style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                    <div>
                        <Button disabled={disabled} className={clockingButtonClass} block onClick={()=>{this.onSwitchPanel("clocking")}}>{translator.getLabel("clocking")}</Button>
                        <Button disabled={disabled} className={rotaButtonClass} block style={{marginTop:'10px'}} onClick={()=>{this.onSwitchPanel("rota")}}>{translator.getLabel("rota")}</Button>
                    </div>
                    <Button className='btn-cancel' block 
                            onClick={()=>
                                {
                                    stateManager.getStore().dispatch(navigationDialogueAction.createAction(null))
                                    if (this.state.clockedInOutCurrentSession)
                                        stateManager.getStore().dispatch(staffLoginAction.createAction(null));

                                }}>{translator.getLabel("exit")}</Button>
               </div>
    }

    

    renderStaffPicture()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        var pictUrl =  themeUtil.getPublicId('staff.png');

        if (!stringUtil.isStringNullOrEmpty(this.props.staff.pictUrl))
        {
            cloudName = configurationManager.getConfig().cdnUsersCloudName;
            pictUrl = this.props.staff.pictUrl;
        }

        var height = Math.round(window.innerHeight * 0.20);
        
        return <CdnImage cloudName={cloudName} width={height} height={height} publicId={pictUrl}/>
    }

    async loadDetails()
    {
        try
        {
            let attendanceEndDate = dateUtil.getToday();
            let attendanceFromDate = dateUtil.subtractDays(attendanceEndDate, 1);
            let attendanceResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/attendance?start=${attendanceFromDate}&end=${attendanceEndDate}`;
    
            let rotaFromDate = dateUtil.getToday();
            let rotaEndDate = dateUtil.addDays(rotaFromDate, 10);
            let rotaResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/rota?start=${rotaFromDate}&end=${rotaEndDate}`;
    
            let results = await rmsApiProxyRetry.get([rotaResourceUrl, attendanceResourceUrl]);
            
            this.state.rotas = results[0];
            if (this.state.rotas == null)
                this.state.rotas = [];
            this.state.rotas = this.state.rotas.filter(r => r.staffId == this.props.staff.id);
            this.state.rotas = arraySort(this.state.rotas, "start")
            
            this.updateLastClockedInDateTime(results[1]);
            this.state.status = "details.loaded";
            this.setState({});
        }
        catch(error)
        {
            this.state.lastClockedInDateTime = null;
            this.state.rotas = [];
            this.state.error = error;
            this.state.status = "error";
            this.setState({});
        }
    }

    updateLastClockedInDateTime(attendances)
    {
        this.state.lastClockedInDateTime = null
        attendances.forEach (attendance =>
        {
             if (attendance.staffId != this.props.staff.id)
                return;
                
            if (attendance.adjustedStart == null || attendance.adjustedEnd != null)
                return;
            
            if (this.state.lastClockedInDateTime == null || dateUtil.isAfter(attendance.adjustedStart, this.state.lastClockedInDateTime))
                this.state.lastClockedInDateTime = attendance.adjustedStart;
            
        })
    }

    onSwitchPanel(targetPanel)
    {
        logger.usage("Clocking.SwitchPanel", `Staff clicked to switch panel to ${targetPanel}`);
        
        if (this.state.panelSelection == targetPanel)
            return;

        this.state.panelSelection = targetPanel;
        this.setState({});
    }

    onClockIn()
    {
        logger.usage("Clocking.ClockIn", "Staff clicked to clock-in");
        jobsServer.addJob(guidUtil.generateGuid(), "Payroll.ClockIn",
                      async ()=>
                      {
                            let attendanceResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/attendance/clockInOut?staffId=${this.props.staff.id}`;
                            await rmsApiProxyRetry.post(attendanceResourceUrl);
                      }, true);

        this.state.lastClockedInDateTime = dateUtil.getNow();
        this.state.clockedInOutCurrentSession = true;
        this.setState({});
    }

    onClockOut()
    {
        logger.usage("Clocking.ClockOut", "Staff clicked to clock-out");
        jobsServer.addJob(guidUtil.generateGuid(), "Payroll.ClockOut",
                      async ()=>
                      {
                            let attendanceResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/attendance/clockInOut?staffId=${this.props.staff.id}`;
                            await rmsApiProxyRetry.post(attendanceResourceUrl);
                      }, true);

        this.state.lastClockedOutDateTime = dateUtil.getNow();
        this.state.clockedInOutCurrentSession = true;
        this.setState({});
    }

}

export default ClockingView;